module.exports = __webpack_public_path__ + "img/rotate.8e41c341.svg";